import { render, staticRenderFns } from "./ProductoForm.vue?vue&type=template&id=27b0ed21&scoped=true"
import script from "./ProductoForm.vue?vue&type=script&lang=js"
export * from "./ProductoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0ed21",
  null
  
)

export default component.exports